<template></template>

<script>
    /**
     * This component is mainly used to initially load data to the base store.
     */
    export default {
        name: "VuexDataLoader",

        props: {
            site: {},
            user: {}
        },

        created() {
            this.$store.commit('setSite', this.site);
            this.$store.commit('setUser', this.user);
        }
    }
</script>